import { Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import clsx from "clsx";

import { GroupedCameraNavigation } from "@/store/userLists/types";

import Camera from "../Camera/Camera";
import CameraGroupName from "./CameraGroupName";
import { useStyles } from "./CameraNav.styles";


interface CameraNavProps {
    activeCameraId: number | null;
    cameras?: GroupedCameraNavigation[];
    streamDeactivated?: boolean
}


const CameraNav: React.FC<CameraNavProps> = ({ activeCameraId, cameras, streamDeactivated }) => {
    const muiClasses = useStyles();

    const contents = cameras && cameras.length !== 0
        ? cameras
            .map((cameraGroup) => {
                const activeGroup = cameraGroup.cameras.reduce((isActive, camera)=>{
                    return isActive || camera.id === activeCameraId;
                },false);

                const validCameras = cameraGroup.cameras.filter((camera)=>{
                    if (streamDeactivated) {
                        return true;
                    } else {
                        return camera.active;
                    }
                });

                if (validCameras.length) {
                    return(
                        <li key={cameraGroup.liveUnitId}>
                            <CameraGroupName active={activeGroup} name={cameraGroup.liveUnitName} />
                            <div className={muiClasses.camListSection}>
                                {validCameras.map(camera => <Camera key={camera.id} camera={camera} active={camera.id===activeCameraId}/>)}
                            </div>
                        </li>
                    );
                }
            })
        : <></>;

    return (
        <div className={muiClasses.root}>

            {cameras != null
                    ? (
                        <>
                            {cameras.length > 0 && <Typography variant="h5" className={muiClasses.camListSectionHeader}>At this Location</Typography>}
                            <div className={clsx(muiClasses.camList, cameras == null && muiClasses.loadingCamList)}>
                                {contents}
                            </div>
                        </>
                    )
                    : (
                        <div className={clsx(muiClasses.camList, cameras == null && muiClasses.loadingCamList)}>
                            {Array.from({ length: 5 }, (_, k) => {
                                return (<Skeleton
                                    key={k}
                                    variant="rect"
                                    className={muiClasses.skeletonCamera}
                                    data-testid="streamCamNavPlaceholder"
                                />);
                            })}
                        </div>
                    )}

        </div>
    );
};

export default CameraNav;
